import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
        '& .subtitle': {
            color: '#9B9B9B',
            fontSize: '12px',
        },
        '& .title': {
            color: '#005E96',
            fontSize: '16px',
            textDecoration: 'none',
            cursor: 'pointer',
        },
        '& .crtTitle': {
            color: '#005E96',
            fontSize: '16px',
            fontWeight: 'bold',
        },
    },
    '& .content-wrap': {
        padding: '20px',
        backgroundColor: '#fff',
        '& .item-wrap': {
            marginBottom: '20px',
        },
    },
    '& .page-title': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .title-2': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
    },
    '& .text-title': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .basic-status': {
        width: '110px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: 'gray'
    },
    '& .color-1': {
        backgroundColor: '#F7B500'
    },
    '& .color-2': {
        backgroundColor: '#18C6FF'
    },
    '& .color-3': {
        backgroundColor: 'gray'
    },
    '& .foot': {
        width: '100%',
        padding: '20px',
        backgroundColor: '#fff',
    },
    '& .ml-10': {
        marginLeft: '10px',
    },
    '& .btn': {
        width: '100px',
    },
});